document.querySelectorAll('.faq-expandable:not(.is-backend)').forEach((item) => {
  const header = item.querySelector('.faq-expandable__header')
  if (!header) {
    return
  }

  header.addEventListener('click', () => {
    const isOpen = item.classList.toggle('is-open')
    header.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
  })
})
